/* eslint-disable import/prefer-default-export */
import { ref } from "vue";
import { defineStore } from "pinia";

import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import filters from "@/composables/store/filters";
import useFormValidation from "@/composables/validations/useFormValidation";

const { checkLocalStorage, bindLocalStorage } = useLocalStorage();
const { formHasErrors, getErrorByField } = filters();
const { validateCheckboxField } = useFormValidation();

const formObject = ref({
  potMainPurpose: {
    value: null,
    required: true,
  },
  tnc: {
    value: null,
    error: null,
    required: true,
    validator: validateCheckboxField,
  },
});

export const usePurposeOfTransactionStoreStore = defineStore({
  id: "purposeOfTransactionStore",
  state: () => ({
    form: checkLocalStorage("purposeOfTransactionStore", formObject),
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
  },
  actions: {
    updateValue(field, val) {
      if (!Object.getOwnPropertyDescriptor(this.form, field)) {
        return;
      }

      if (Object.getOwnPropertyDescriptor(this.form[field], "validator")) {
        const { validator } = this.form[field];
        this.form[field].error = validator(field, val);
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
  },
});
